module.exports = __webpack_public_path__ + "img/jaula.8090e027.jpg";